import { c as _c } from "react/compiler-runtime";
import { useVillaReserveCancellationPolicies } from "@website/accommodation-ui/villa-reserve-cancellation-policies/index.hook";
import { villaReserveCancellationPolicyType } from "@website/accommodation-ui/villa-reserve-cancellation-policies/index.types";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { Modal } from "@website/ui/modal";
import { Tabs } from "@website/ui/tabs";
import { FC } from "react";
export const VillaReserveCancellationPolicy: FC<villaReserveCancellationPolicyType> = properties => {
  const $ = _c(19);
  const {
    policiesData,
    openRulesModal,
    isRulesModalOpen,
    closeRulesModal,
    defaultTabPanel
  } = useVillaReserveCancellationPolicies(properties);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p>مشاهده دقیق جزئیات لغو رزرو اقامتگاه</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MaterialIcon name="arrow_left" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== openRulesModal) {
    t2 = <Button color="secondary" className="!m-0 !p-0" variant="text" EndIcon={t1} onClick={openRulesModal}>مشاهده بیشتر</Button>;
    $[2] = openRulesModal;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== defaultTabPanel || $[5] !== policiesData.tabs) {
    t3 = policiesData.tabs.length > 1 ? <Tabs color="secondary" variant="underline" size="fill" tabs={policiesData.tabs} className="!overflow-auto !px-0" panelContainerClassName="!px-0 !py-2" /> : defaultTabPanel;
    $[4] = defaultTabPanel;
    $[5] = policiesData.tabs;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <div className="flex h-full flex-col justify-between overflow-auto"><div className="flex flex-col"><div className="w-full pt-4">{t3}</div></div></div>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== closeRulesModal) {
    t5 = <div className="hidden w-full justify-end bg-white py-2 lg:flex"><Button color="secondary" onClick={closeRulesModal}>متوجه شدم</Button></div>;
    $[9] = closeRulesModal;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== closeRulesModal || $[12] !== isRulesModalOpen || $[13] !== t4 || $[14] !== t5) {
    t6 = <Modal title={"\u0642\u0648\u0627\u0646\u06CC\u0646 \u0644\u063A\u0648 \u0631\u0632\u0631\u0648"} className="flex flex-col justify-between lg:!h-full lg:!max-h-[600px] lg:!w-full lg:!max-w-[448px]" open={isRulesModalOpen} onClose={closeRulesModal} showCloseButton={true} fullWidth={true}>{t4}{t5}</Modal>;
    $[11] = closeRulesModal;
    $[12] = isRulesModalOpen;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t2 || $[17] !== t6) {
    t7 = <div>{t0}{t2}{t6}</div>;
    $[16] = t2;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};